if (!customElements.get('range-slider')) {
  customElements.define(
    'range-slider',
    class RangeSlider extends HTMLElement {
      constructor() {
        super();
        this.range = this.querySelector('input[type="range"]');
        this.bubble = this.querySelector('output');
        this.isRtl = document.dir === 'rtl';
        this.values = this.range.dataset.values.split(',')
      }

      updateBubble (range, bubble) {
        if (bubble.style.display === "none") {
          bubble.style.display = "block";
        }
        const val = range.value;
        const min = range.min ? range.min : 0;
        const max = range.max ? range.max : 100;
        const newVal = Number(((val - min) * 100) / (max - min));
        const newTitle = `${this.values[val]} ס”מ`
        bubble.innerHTML = newTitle;
        document.querySelector('product-customizer').querySelector(`[data-customizer-range]`).value = newTitle;

        bubble.style[this.isRtl ? 'right' : 'left'] = `calc(${newVal}% + (${10 - newVal * 0.16}px) - ${bubble.offsetWidth / 2}px)`;
      }

      connectedCallback () {
        this.updateBubble(this.range, this.bubble);
        this.range.addEventListener('input', () => {
          this.updateBubble(this.range, this.bubble);
        });
      }
    }
  );
}
